import React from "react";
import { KeywordCombinations, NameSectionProps } from "../lib/types";
import LogosOrText from "./LogosOrText";


function NamesListSection(props: NameSectionProps) {


    const shouldShowTextLogos = (): boolean => {
        return !props.useTextLogos || props.textLogoUrls.length > 0
    }



    return (<section className="namesSection">
        <h4 className="h2">{props.title}</h4>
        <div className={"row g-2 namesList"}>

            {shouldShowTextLogos() && props.namesList.map((item, index) => {
                return (
                    <LogosOrText
                        randomOffset={props.randomOffset + (props.sectionType + 1) * 10}
                        textLogoUrls={props.textLogoUrls}
                        key={index}
                        useTextLogos={props.useTextLogos}
                        index={index}
                        item={item}
                        onClick={props.onNameItemClick}
                    />
                )
            })}

        </div>
        {props.showSeeMore(props.sectionType) && <div className="btnSeeMoreWrapper">
            <button className="btnSeeMore" onClick={() => props.onSeeMoreClick(props.sectionType)}>See More</button>
        </div>}
    </section>)
}

export default React.memo(NamesListSection)